import { getVacancyApplicantsAsync, 
        searchJobApplicantsAsync,
        getJobShortlistAsync,
        searchJobShortlistAsync,
        toggleApplicantShortlistAsync,
        deleteAllShortlistedAsync,
        deleteAllApplicantsAsync,
        deleteApplicantAsync } from "@/services/employers/applicantsService"

export const jobApplicants = {
    namespaced: true,
    state:{
       applicants: null,
       applicantsMetaData: null,
       shortlist: null,
       shortlistMetaData: null,
       vacancy: {}
    },
    getters:{
        getApplicants(state){
            return state.applicants
        },
        getApplicantsMetaData(state){
            return state.applicantsMetaData
        },
        getShortlist(state){
            return state.shortlist
        },
        getShortlistMetaData(state){
            return state.shortlistMetaData;
        },
         getVacancy(state){
            if(state.vacancy){
                let _vacancy = sessionStorage.getItem('vacancyInfo');
                return JSON.parse(_vacancy);
                
            }else{
                return state.vacancy
            }
        }
    },
    mutations:{
        //For Applications
        setApplicants(state ,applicants){
            state.applicants = applicants;
        },
        setApplicantsMetaData(state,applicantsMetaData){
            state.applicantsMetaData = applicantsMetaData;
        },
          updateApplicants(state,applicant){
            const _applicant = state.applicants.find(v => v.applicantId === applicant.applicantId);
            if(_applicant){
                _applicant.isShortlisted = applicant.isShortlisted;
                _applicant.isCalled = applicant.isCalled;
                _applicant.isInterviewed = applicant.isInterviewed;
                _applicant.hasPassed = applicant.hasPassed;    
            }
        },
        removeApplicant(state,applicantId){
           state.applicants = state.applicants.filter(v => v.applicantId !== applicantId); 
        },
        removeAllApplicants(state){
            state.applicants = [];
            state.applicantsMetaData = null;
        },
        removeAPermanentlyDeletedApplicant(state,applicantId){
           state.applicants = state.applicants.filter(v => v.applicantId !== applicantId); 
        },

        //For shortlist
        setShortlist(state ,shortlist){
            state.shortlist = shortlist;
        },
         setShortlistMetaData(state,shortlistMetaData){
            state.shortlistMetaData = shortlistMetaData;
        },
        updateShortlist(state,applicant){
            const _applicant = state.shortlist.find(v => v.applicantId === applicant.applicantId);
            if(_applicant){
                _applicant.isShortlisted = applicant.isShortlisted;   
                _applicant.isCalled = applicant.isCalled;
                _applicant.isInterviewed = applicant.isInterviewed;
                _applicant.hasPassed = applicant.hasPassed;
            }
        },
        removeShortlistedApplicant(state,applicantId){
           state.shortlist = state.shortlist.filter(v => v.applicantId !== applicantId); 
        },
        removeAllShortlisted(state){
            state.shortlist = [];
            state.shortlistMetaData = null;
        },


        updateSelectedVacancy(state, vacancy){
            state.vacancy = vacancy
        }

  
    },
    actions: {
        //For Applicants
        async getApplicantsAsync({commit}, {jobId, page}){
            
                   var response = await getVacancyApplicantsAsync(jobId,page);
                   if(!response.success){
                           const err = new Error(res.message, {reason: response.caption});
                           err.caption = res.caption;
                           throw err;
                       }else{
                  
                           commit('setApplicants', response.applicants);
                           commit('setApplicantsMetaData', response.meta);
                       }
               },
       
          async searchApplicantsAsync({commit}, content){
                    var response = await searchJobApplicantsAsync(content.data,content.page);
                    if(!response.success){
                            if(!response.errors){
                            const err = new Error(response.message, {reason: response.caption});
                            err.caption = response.caption;
                            throw err;
                            }else{
                                var errorMessages = "";
                                console.log(response.errors);
                                for(var error of response.errors){
                                    errorMessages += `${error}<br/>`;
                                }
                                throw new Error(errorMessages, {reason: response.caption})
                            }
                        }else{
                            commit('setApplicants', response.applicants);
                            commit('setApplicantsMetaData', response.meta);
                        }
            },

             updateApplicants({commit}, content){
                commit('updateApplicants', content);
             },
            removeApplicant({commit}, content){
                commit(' removeApplicant', content);
            },
            removeAllApplicants({commit},content){
                commit('removeAllApplicants',content);
            },
            async deleteSelectedJobApplicantAsync({commit}, content){
                            var response = await deleteApplicantAsync(content);
                            if(!response.success){     
                                    const err = new Error(response.message, {reason: response.caption});
                                    err.caption = response.caption;
                                    throw err;
                                }else{
                                    commit(' removeApplicant', content.applicantId);
                            }
            },
            removeAPermanentlyDeletedApplicant({commit}, content){
                commit('removeAPermanentlyDeletedApplicant', content);
            },

            async deleteAllJobApplicantsAsync({commit}, content){ // content: jobId
                            var response = await deleteAllApplicantsAsync(content);
                            if(!response.success){     
                                    const err = new Error(response.message, {reason: response.caption});
                                    err.caption = response.caption;
                                    throw err;
                                }else{
                                    commit('removeAllApplicants');
                            }
            },


            //For Shortlisted
             async getShortlistAsync({commit}, {jobId, page}){
                   var response = await getJobShortlistAsync(jobId,page);
                   if(!response.success){
                           const err = new Error(res.message, {reason: response.caption});
                           err.caption = res.caption;
                           throw err;
                       }else{
                  
                           commit('setShortlist', response.shortlist);
                           commit('setShortlistMetaData', response.meta);
                       }
               },
                async searchShortlistAsync({commit}, content){
                    var response = await searchJobShortlistAsync(content.data,content.page);
                    if(!response.success){
                            if(!response.errors){
                            const err = new Error(response.message, {reason: response.caption});
                            err.caption = response.caption;
                            throw err;
                            }else{
                                var errorMessages = "";
                                console.log(response.errors);
                                for(var error of response.errors){
                                    errorMessages += `${error}<br/>`;
                                }
                                throw new Error(errorMessages, {reason: response.caption})
                            }
                        }else{
                            commit('setShortlist', response.shortlist);
                            commit('setShortlistMetaData', response.meta);
                        }
                },
                updateShortlist({commit}, content){
                    commit('updateShortlist',content);
                },
                removeShortlistedApplicant({commit}, content){
                    commit('removeShortlistedApplicant', content);
                },
                 
                async deleteAllJobShortlistedAsync({commit}, content){ // content: jobId
                            var response = await deleteAllShortlistedAsync(content);
                            if(!response.success){     
                                    const err = new Error(response.message, {reason: response.caption});
                                    err.caption = response.caption;
                                    throw err;
                                }else{
                                    commit('removeAllShortlisted');
                            }
                }




            


         
    }
}